import { RewardMapType } from "@hg/activity-utils"
import { RequestCode } from "@hg/recall-frame"

export const errMsgMap = {
    [RequestCode.ACTIVITY_NOT_FOUND]: "message.activity_meta_error",
    [RequestCode.ACTIVITY_NOT_START]: "message.activity_not_start",
    [RequestCode.ACTIVITY_ENDED]: "message.activity_ended",
    [RequestCode.ACTIVITY_CHECKER_LEVEL_TOO_LOW]: "message.level_to_low",
    [RequestCode.TEAM_NOT_FOUND]: "message.search_no_team",
    [RequestCode.TEAM_CANT_JOIN_OWN]: "message.join_myself",
    [RequestCode.TEAM_HAS_MEMBER_ALREADY]: "message.join_team_full",
    [RequestCode.TEAM_JOIN_ALREADY]: "message.join_failed",
    [RequestCode.TEAM_RECALL_PLAYER_ONLY]: "message.not_recall_member",
    [RequestCode.TEAM_RECALL_OR_NEW_PLAYER_ONLY]:
        "message.not_recall_or_new_player",
    [RequestCode.DRAW_NO_COUPON]: "message.no_chance",
    [RequestCode.DRAW_NO_RESULT]: "message.draw_no_result",
    [RequestCode.DRAW_CONTACT_FILL_ALREADY]:
        "message.draw_contact_fill_already",
    [RequestCode.DRAW_CONTACT_FILL_INVALID]:
        "message.draw_contact_fill_invalid",
    [RequestCode.GIFT_SERVICE_DRAW_EXCEED]: "message.draw_fail",
    [RequestCode.GIFT_SERVICE_DRAW_DAILY_EXCEED]: "message.draw_error",
    [RequestCode.GAME_SERVICE_NO_ROLE_PROFILE]: "message.gm_service_error",
    [RequestCode.GAME_SERVICE_STAT_NOT_FOUNT]: "message.gm_service_error",
}

export const RewardMap: RewardMapType = {
    share_goods: {
        type: "real",
        key: "real_good_A",
        title: "reward.text_prizeA",
        src: require("@/assets/imgs/common/prize_A.png"),
    },
    LMD: { type: "virtual", key: "4001", title: "reward.text_lmb" },
}